"use client";

import { useState } from "react";
import clsx from "clsx";
import { CgSpinner } from "@react-icons/all-files/cg/CgSpinner";

type Props = {
  video: string;
};

const VideoIframe = ({ video }: Props) => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  return (
    <>
      {!isIframeLoaded && <CgSpinner className="mx-auto size-16 animate-spin text-white" />}
      <iframe
        className={clsx("z-0 mx-auto aspect-video size-full md:w-[738px] lg:w-[940px]", {
          visible: isIframeLoaded,
          hidden: !isIframeLoaded,
        })}
        src={video}
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
        onLoad={() => setIsIframeLoaded(true)}
      ></iframe>
    </>
  );
};

VideoIframe.displayName = "VideoIframe";

export { VideoIframe };
